import React from 'react'
import { useTranslation } from 'react-i18next'

const NotForIE = () => {

  const { t } = useTranslation()

  return (
    <div className="ie-error">
      <h2>{t("We' a're sorry")}</h2>
      <p>{t("In order to ensure the highest quality of services, our website does not support Internet Explorer.")}</p>
    </div>
  )
}

export default NotForIE